import { render, staticRenderFns } from "./DashboardRefunds.vue?vue&type=template&id=0b8b95a7"
import script from "./DashboardRefunds.vue?vue&type=script&lang=js"
export * from "./DashboardRefunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports